export const COUPON_LOADING = 'COUPON_LOADING';
export const COUPON_LIST = 'COUPON_LIST';
export const COUPON_MY_LIST = 'COUPON_MY_LIST';
export const COUPON_DETAIL = 'COUPON_DETAIL';
export const COUPON_ERROR = 'COUPON_ERROR';
export const COUPON_SHOW_LEGALS = 'COUPON_SHOW_LEGALS';
export const COUPON_AMOUNT = 'COUPON_AMOUNT';
export const COUPON_TOTAL = 'COUPON_TOTAL';
